var _excluded = ["index", "children", "data-testid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from 'react';
import { Card, Collapsible, Container } from '../../../../../containers';
import { useTestId } from '../../../../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var MobileListItem = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    index,
    children,
    'data-testid': dataTestId = 'form-line-items-mobile-list-item'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var getTestId = useTestId(dataTestId);
  return /*#__PURE__*/_jsx(Card, _objectSpread(_objectSpread(_objectSpread({
    variant: "flat",
    paddingX: "s",
    paddingY: "s"
  }, getTestId), props), {}, {
    ref: ref,
    children: /*#__PURE__*/_jsx(Container, {
      width: "full",
      children: /*#__PURE__*/_jsx(Collapsible, {
        label: "#".concat(index + 1),
        labelView: "full",
        children: children
      })
    })
  }));
});
MobileListItem.displayName = 'FormLineItems.MobileListItem';
//# sourceMappingURL=MobileListItem.js.map